function ReferentAuth(data){
    let referentAuth = data || {};
    this.phoneNumber = referentAuth.phoneNumber;
    this.email = referentAuth.email;
    this.password = referentAuth.password;
    this.twoFactorAuthenticationToken = referentAuth.twoFactorAuthenticationToken;
    this.jwtToken = referentAuth.jwtToken;
}
module.exports = ReferentAuth;